import { initAsideMenu } from '../components/asideMenu'
import { lazyLoadBgImages } from '../components/lazyLoadBgImages'

import '../components/inlineCopy'

import './../../scss/main.scss'

document.fonts.ready.then(function () {
    document.body.classList.remove('font-fallback')
})

document.addEventListener('DOMContentLoaded', () => {
    const asideToggle = document.querySelector('.toggle-menu')
    const aside = document.querySelector('.aside-menu')
    initAsideMenu(aside, asideToggle)
    lazyLoadBgImages()
})

// eslint-disable-next-line no-undef
if (BS_ON === 'true' && NODE_ENV === 'development') {
    const script = document.createElement('script')
    // eslint-disable-next-line no-undef
    script.src = `http://localhost:${BS_PORT}/browser-sync/browser-sync-client.js`
    document.head.appendChild(script)
}
